import React from "react";

/**
 * DigitalSetu bridge (setu) logo mark. Blue arch + orange sun over water lines.
 * Props:
 *   size    — px height (width auto-scaled)
 *   variant — "color" (default) | "mono" (white on dark) | "dark"
 */
export default function DigitalSetuLogo({ size = 40, variant = "color" }) {
  const width = size * 1.1;
  const primary  = variant === "mono" ? "#ffffff" : "#1e3a8a";
  const accent   = variant === "mono" ? "#ffffff" : "#ea580c";
  const secondary = variant === "mono" ? "#ffffff" : "#059669";
  return (
    <svg viewBox="0 0 48 48" width={width} height={size} xmlns="http://www.w3.org/2000/svg" aria-label="DigitalSetu" role="img">
      {/* sun / accent circle */}
      <circle cx="24" cy="14" r="4" fill={accent} />
      {/* bridge deck */}
      <rect x="6" y="26" width="36" height="3.4" rx="1.2" fill={primary} />
      {/* bridge arches */}
      <path d="M 8 28 Q 16 18 24 28" stroke={primary} strokeWidth="2.4" fill="none" strokeLinecap="round" />
      <path d="M 24 28 Q 32 18 40 28" stroke={primary} strokeWidth="2.4" fill="none" strokeLinecap="round" />
      {/* central pillar */}
      <rect x="23" y="20" width="2" height="8" fill={primary} />
      {/* water lines */}
      <path d="M 6 36 Q 12 34 18 36 T 30 36 T 42 36" stroke={secondary} strokeWidth="1.6" fill="none" strokeLinecap="round" opacity="0.9" />
      <path d="M 6 40 Q 12 38 18 40 T 30 40 T 42 40" stroke={secondary} strokeWidth="1.2" fill="none" strokeLinecap="round" opacity="0.55" />
    </svg>
  );
}
